import {
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_DARK,
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
  SEM_COLOR_FEEDBACK_SURFACE_ERROR_DARK,
  SEM_COLOR_FEEDBACK_SURFACE_ERROR_LIGHT,
  SEM_COLOR_FEEDBACK_SURFACE_SUCCESS_DARK,
  SEM_COLOR_FEEDBACK_SURFACE_SUCCESS_LIGHT,
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
} from '@oneaudi/unified-web-common';
import { SYS_COLOR_CANVAS_200_DARK } from '@oneaudi/unified-web-alpha-common';
import type { CustomTheme } from '../../@types/theme';
import { THEME } from '../types';

const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};
const colorsDark = {
  background: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_DARK,
  error: SEM_COLOR_FEEDBACK_SURFACE_ERROR_DARK,
  success: SEM_COLOR_FEEDBACK_SURFACE_SUCCESS_DARK,
  colorCanvas200: SYS_COLOR_CANVAS_200_DARK,
};

const colorsLight = {
  background: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
  error: SEM_COLOR_FEEDBACK_SURFACE_ERROR_LIGHT,
  success: SEM_COLOR_FEEDBACK_SURFACE_SUCCESS_LIGHT,
};

export const darkTheme: CustomTheme = {
  name: THEME.DARK,
  colors: colorsDark,
  breakpoints,
};

export const lightTheme: CustomTheme = {
  name: THEME.LIGHT,
  colors: colorsLight,
  breakpoints,
};
